/**
 * ES Search overlay enhancement
 * - Keeps existing /search?view=json endpoint
 * - Adds: focus on open, clear button, recent & popular chips, better loading/empty states,
 *         abortable + debounced requests, ESC close
 * - Designed to be low-risk: does NOT change the open/close mechanism from engo-core.js
 */
(function($){
  'use strict';

  var SELECTOR_INPUT = '.search-full-destop .js_engo_autocomplate';
  var KEY_RECENT = 'es_recent_searches_v1';

  // Popular chips (on-brand) — edit labels/queries anytime.
  // Tip: use short, shopper-friendly terms; q can be any keyword.
  // Popular chips (edit anytime). Keep labels short & product-focused.
  // Tip: use queries that are likely to appear in titles/tags (e.g. “wide”, “titanium”, model #).
  var POPULAR = [
    { label: 'Sonnenbrillen',       q: 'sonnenbrille' },
    { label: 'Sport',           q: 'sportbrille' },
    { label: 'Rechteckig',        q: 'rechteckig' },
    { label: 'Umgekehrter Halbrand', q: 'Umgekehrter Halbrand' },
    { label: 'Asymmetrisch',       q: 'asymmetrisch' },
    { label: 'Breite Passform',         q: 'breite passform' },
    { label: 'Titan',         q: 'titan' },
    { label: 'Quadratisch',           q: 'quadratisch' },
    { label: 'Rund',            q: 'rund' }
  ];

  // Used in empty state to give people a way out.
  var EMPTY_SUGGEST = ['breit', 'titan', 'quadratisch', 'rund', 'rechteckig', 'sport', 'asymmetrisch', 'sonnenbrille'];

  var xhr = null;
  var debounceTimer = null;
  var isComposing = false;
  // How many products to show in the quick results grid.
  // Desktop is 4 columns, so 8 gives a clean 2-row preview.
  var MAX_QUICK_RESULTS = 8;

  function $overlay(){ return $('.search-full-destop .js-box-search'); }
  function $input(){ return $(SELECTOR_INPUT).first(); }
  function $results(){ return $('.search-full-destop .js_search_results').first(); }
  function $wrapper(){ return $('.search-full-destop .js_productSearchResults').first(); }
  function $suggest(){ return $('.search-full-destop .es-search-suggest').first(); }
  function $viewAll(){ return $('.search-full-destop [data-es-viewall]').first(); }
  function $clearBtn(){ return $('.search-full-destop .es-search-clear').first(); }

  function escapeRegExp(str){
    return (str || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function safeText(str){
    // Basic HTML escaping for dynamic titles (defense-in-depth)
    return (str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getRecent(){
    try{
      var raw = window.localStorage.getItem(KEY_RECENT);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    }catch(e){
      return [];
    }
  }

  function setRecent(arr){
    try{
      window.localStorage.setItem(KEY_RECENT, JSON.stringify(arr.slice(0, 8)));
    }catch(e){}
  }

  function clearRecent(){
    try{
      window.localStorage.removeItem(KEY_RECENT);
    }catch(e){}
  }

  function addRecent(q){
    q = (q || '').trim();
    if(!q) return;
    var arr = getRecent();
    arr = arr.filter(function(x){ return (x || '').toLowerCase() !== q.toLowerCase(); });
    arr.unshift(q);
    setRecent(arr);
  }

  function renderChips($root, items){
    if(!$root || !$root.length) return;
    if(!items || !items.length){
      $root.html('<span class="es-search-empty">No recent searches</span>');
      return;
    }
    var html = items.map(function(it){
      var label = safeText(it.label || it.q || it);
      var q = safeText(it.q || it);
      return '<button type="button" class="es-suggest-chip" data-q="'+ q +'">'+ label +'</button>';
    }).join('');
    $root.html(html);
  }

  function renderSuggest(){
    var $s = $suggest();
    if(!$s.length) return;

    renderChips($s.find('[data-es-popular]'), POPULAR);

    var rawRecent = getRecent();
    var rec = rawRecent.map(function(q){ return ({label: q, q: q}); });
    renderChips($s.find('[data-es-recent]'), rec);

    // Show "Clear" only when there is something to clear.
    $s.find('[data-es-recent-clear]').toggle(!!rawRecent.length);

    $s.show();
  }

  function showSuggest(){
    var $s = $suggest();
    if($s.length) $s.show();
    $viewAll().hide().empty();
    $wrapper().hide();
  }

  function hideSuggest(){
    var $s = $suggest();
    if($s.length) $s.hide();
  }

  function setClearVisible(visible){
    var $btn = $clearBtn();
    if(!$btn.length) return;
    $btn.toggleClass('is-visible', !!visible);
  }

  function clearResults(){
    $results().empty();
    $viewAll().hide().empty();
    $wrapper().hide();
  }

  function skeleton(){
    // Base theme keeps `.js_search_results` as a Bootstrap `.row`.
    // Without a full-width column wrapper, our grid can shrink to the left
    // and look like a tiny "stack of boxes" while loading.
    var html = '<div class="col-12 es-search-grid-wrap"><div class="es-search-grid">';
    for(var i=0;i<MAX_QUICK_RESULTS;i++){
      html += ''+
        '<div class="es-scard es-skel" aria-hidden="true">'+
          '<div class="es-scard__img">'+
            '<div class="es-skel-img"></div>'+
          '</div>'+
          '<div class="es-scard__meta">'+
            '<div class="es-skel-line"></div>'+
            '<div class="es-skel-line small"></div>'+
          '</div>'+
        '</div>';
    }
    html += '</div></div>';
    $wrapper().show();
    $results().html(html);
  }

  function renderEmpty(q){
    $wrapper().show();
    var chips = EMPTY_SUGGEST.map(function(x){
      return '<button type="button" class="es-suggest-chip es-suggest-chip--mini" data-q="'+ safeText(x) +'">'+ safeText(x) +'</button>';
    }).join('');
    $results().html(
      '<div class="col-12 es-search-grid-wrap">'+
        '<div class="es-search-empty-state">'+
          'No results for <strong>'+ safeText(q) +'</strong>.'+
          '<div class="es-search-empty-sub">Try: '+ chips +'</div>'+
        '</div>'+
      '</div>'
    );
    $viewAll().hide().empty();
  }

  function renderError(){
    $wrapper().show();
    $results().html(
      '<div class="col-12 es-search-grid-wrap">'+
        '<div class="es-search-empty-state">Search is temporarily unavailable. Please try again.</div>'+
      '</div>'
    );
    $viewAll().hide().empty();
  }

  function renderViewAll(q){
    var url = '/search?q=' + encodeURIComponent(q) + '&type=product';
    // UX copy: keep the action short & clear
    // Keep the CTA compact. Make the arrow part of the text so spacing looks natural.
    $viewAll().html('<a class="es-search-viewall-btn" href="'+ url +'">Alle anzeigen &#8250;</a>').show();
  }

  function highlight(text, q){
    if(!q) return safeText(text);
    var re = new RegExp('(' + escapeRegExp(q) + ')', 'ig');
    return safeText(text).replace(re, '<span class="hightlight">$1</span>');
  }

  function renderProducts(products, q){
    var html = '<div class="col-12 es-search-grid-wrap"><div class="es-search-grid">';
    for(var i=0;i<products.length;i++){
      var p = products[i];
      if(!p) continue;

      // NOTE: Liquid output {{ search.results | json }} for products may not include `url`
      // in some themes/stores. Always build a safe fallback from handle.
      var url = p.url || p.online_store_url || (p.handle ? ('/products/' + p.handle) : '#');
      var title = p.title || '';
      var img = (p.featured_image && (p.featured_image.url || p.featured_image)) || '';
      var price = p.price;
      var compare = p.compare_at_price;

      html += '<a class="es-scard" href="'+ url +'" aria-label="'+ safeText(title) +'">';
      html +=   '<span class="es-scard__img">';
      html +=     '<img loading="lazy" alt="'+ safeText(title) +'" src="'+ img +'">';
      html +=   '</span>';
      html +=   '<span class="es-scard__meta">';
      html +=     '<span class="es-scard__title">'+ highlight(title, q) +'</span>';
      html +=     '<span class="es-scard__price">';
      if(typeof Shopify !== 'undefined' && Shopify.formatMoney && typeof price !== 'undefined'){
        html +=       '<span class="price">'+ Shopify.formatMoney(price, window.money_format || '{{amount}}') +'</span>';
        if(typeof compare !== 'undefined' && compare > price){
          html +=     '<span class="price-old">'+ Shopify.formatMoney(compare, window.money_format || '{{amount}}') +'</span>';
        }
      }
      html +=     '</span>';
      html +=   '</span>';
      html += '</a>';
    }
    html += '</div></div>';
    $results().html(html);
    renderViewAll(q);
  }

  function doSearch(q){
    // Abort in-flight
    if(xhr && xhr.readyState !== 4){
      try{ xhr.abort(); }catch(e){}
    }
    skeleton();

    xhr = $.ajax({
      url: '/search',
      type: 'GET',
      dataType: 'json',
      data: {
        q: '*' + q + '*',
        type: 'product',
        view: 'json'
      }
    }).done(function(data){
      // Expect array of product objects
      if(!Array.isArray(data) || data.length === 0){
        renderEmpty(q);
        return;
      }
      renderProducts(data.slice(0, MAX_QUICK_RESULTS), q);
    }).fail(function(){
      // Ignore abort errors
      if(xhr && xhr.statusText === 'abort') return;
      renderError();
    });
  }

  function queueSearch(q){
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(function(){
      doSearch(q);
    }, 180);
  }

  function focusInput(){
    var $i = $input();
    if(!$i.length) return;
    window.setTimeout(function(){
      $i.trigger('focus');
      try{
        var val = $i.val() || '';
        if($i[0] && $i[0].setSelectionRange){
          $i[0].setSelectionRange(val.length, val.length);
        }
      }catch(e){}
    }, 60);
  }

  function isOpen(){
    return $overlay().hasClass('active');
  }

  function init(){
    var $i = $input();
    if(!$i.length) return;

    // Tell legacy keyup handler to skip this input (patched in engo-core.js)
    $i.data('esSearchEnhanced', true);

    // Initial UI
    renderSuggest();
    setClearVisible(!!($i.val() || '').trim());

    // Open -> focus (works with existing open handler)
    $(document).on('click.essearch', '.js-search-destop', function(){
      $('body').addClass('es-search-open');
      renderSuggest();
      focusInput();
    });

    // Close -> cleanup
    $(document).on('click.essearch', '.search-full-destop .js-drawer-close, .search-full-destop .bg_search_box', function(){
      $('body').removeClass('es-search-open');
    });

    // ESC close (uses existing close button)
    $(document).on('keydown.essearch', function(e){
      if(e.key === 'Escape' && isOpen()){
        $('.search-full-destop .js-drawer-close').trigger('click');
      }
    });

    // Clear button
    $(document).on('click.essearch', '.search-full-destop .es-search-clear', function(){
      var $in = $input();
      $in.val('');
      setClearVisible(false);
      clearResults();
      showSuggest();
      focusInput();
    });

    // Clear recent searches
    $(document).on('click.essearch', '.search-full-destop [data-es-recent-clear]', function(){
      clearRecent();
      clearResults();
      renderSuggest();
      showSuggest();
      focusInput();
    });

    // Suggestion chip click
    $(document).on('click.essearch', '.search-full-destop .es-suggest-chip', function(){
      var q = ($(this).attr('data-q') || '').trim();
      if(!q) return;
      var $in = $input();
      $in.val(q);
      setClearVisible(true);
      hideSuggest();
      queueSearch(q);
      focusInput();
    });

    // Submit: store as recent
    $(document).on('submit.essearch', '.search-full-destop .wg-search-form', function(){
      var q = ($input().val() || '').trim();
      addRecent(q);
    });

    // IME composition handling
    $(document).on('compositionstart.essearch', SELECTOR_INPUT, function(){ isComposing = true; });
    $(document).on('compositionend.essearch', SELECTOR_INPUT, function(){
      isComposing = false;
      $(this).trigger('input');
    });

    // Input changes
    $(document).on('input.essearch', SELECTOR_INPUT, function(){
      var q = ($(this).val() || '').trim();
      setClearVisible(!!q);

      if(isComposing) return;

      if(q.length < 2){
        if(xhr && xhr.readyState !== 4){
          try{ xhr.abort(); }catch(e){}
        }
        clearResults();
        showSuggest();
        return;
      }
      hideSuggest();
      queueSearch(q);
    });
  }

  $(init);

})(jQuery);
